module.exports = __webpack_public_path__ + "img/minei-pe-luna-octombrie-1776-pagina-de-titlu-big.492e7046.jpg";